/**
 * @file index.tsx
 * @description Re-exports the ContractDrawerTabs container as the
 *   public entry point. Callers import from `@/.../ContractDrawerTabs`
 *   rather than the container file directly.
 * @module features/contracts/components/ContractDrawerTabs
 */

export { default } from "./ContractDrawerTabsContainer";
export type { ContractDrawerTabsContainerProps } from "./ContractDrawerTabsContainer";
export type { ContractDrawerTabKey } from "./ContractDrawerTabsView";
